const GreenHeroShape = ({ ...props }) => {
  return (
    <svg
      width="102"
      height="310"
      viewBox="0 0 102 310"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="-12.0547"
        y="-41"
        width="205.652"
        height="339.867"
        rx="100"
        transform="rotate(41.2178 -12.0547 -41)"
        fill="url(#paint0_linear_953_3852)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_953_3852"
          x1="101.247"
          y1="-44.5327"
          x2="87.4875"
          y2="163.61"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#34A853" />
          <stop offset="1" stopColor="#B8D344" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GreenHeroShape;
